<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formMarksLegalsPg" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12">
            <h3>Portada</h3>
          </v-col>

          <v-col cols="12" md="2">
            <label for="upload">Archivo de carga</label>
          </v-col>

          <v-col cols="12" md="4" class="pb-0">
            <v-file-input
              id="upload"
              v-model="file_upload"
              outlined
              prepend-icon=""
              dense
              placeholder="Elige un archivo"
              @change="onFileChange"
            ></v-file-input>
          </v-col>

          <v-col cols="12">
            <div class="img-cover section">
              <img draggable="false" :src="url || loadImage(marksLegalsPg.upload)" :alt="marksLegalsPg.text" />
              <h1 class="cover-title">{{ marksLegalsPg.title_cover_page }}</h1>
            </div>
          </v-col>

          <v-col cols="12" md="2">
            <label for="description_about">Contenido de la regulacción</label>
          </v-col>

          <v-col cols="12" md="10" class="pb-0">
            <v-textarea
              id="description_about"
              v-model="marksLegalsPg.regulation"
              outlined
              dense
              placeholder="Detalle de la regulacción"
              rows="5"
              :rules="required"
            ></v-textarea>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import DataTableFinalities from '@/components/data-table/DataTableFinalities.vue'
import DataTableValues from '@/components/data-table/DataTableValues.vue'
import { loadAPIImage } from '@/utils/images'
export default {
  components: {
    FormTemplate,
    DataTableFinalities,
    DataTableValues,
  },
  props: {
    getMarksLegalsPg: Function,
    loading: Boolean,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      url: '',
      file_upload: null,
      marksLegalsPg: {},
    }
  },
  async created() {
    this.marksLegalsPg = await this.getMarksLegalsPg()
  },
  methods: {
    validateForm() {
      return this.$refs.formMarksLegalsPg.validate()
    },
    reset() {
      this.$refs.formMarksLegalsPg.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      let DTO = { ...this.marksLegalsPg }

      if (this.file_upload) {
        DTO = {
          ...DTO,
          file_upload: this.file_upload,
        }
      }

      // // console.log('actualizar', DTO)
      this.$emit('beforeUpdate', DTO)
    },
    onFileChange(e) {
      if (!e) return
      this.url = URL.createObjectURL(e)
    },
    onFileNewChange(e) {
      if (!e) return
      this.urlNew = URL.createObjectURL(e)
    },
    loadImage(src) {
      return loadAPIImage(src)
    },
  },
}
</script>

<style lang="scss" scoped>
.img-cover {
  height: 30vh;
  max-height: 400px !important;
  min-height: 250px !important;
  position: relative;
}

.img-cover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

.img-cover .cover-title {
  width: 100%;
  position: absolute;
  bottom: 10%;
  color: white !important;
  font-size: 25px;
  margin-left: 10%;
  text-transform: uppercase;
}

.img-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

.img-about {
  width: 100%;
}

.title-about {
  font-size: 25px;
  font-weight: 800;
  text-transform: uppercase;
}

.content-about {
  display: flex;
  align-items: center;
}

.text-about {
  white-space: pre-wrap;
  font-size: 14px;
}

.section {
  margin: 0 auto;
  max-width: 900px;
}
</style>
